
import React, {useEffect,useState} from 'react';
import Pagination from "react-js-pagination";
import Cookies from "universal-cookie";
import axios from "axios";
import Host, { FrontEndDomain } from "../../../assets/js/Host";
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import SurveyForm from './SurveyForm';
import SurveyView from './SurveyView';


const cookies = new Cookies();
const token = cookies.get("token")
const language = cookies.get("language")?cookies.get("language"):"ar"
function Surveys() {

    const [loading, setloading] = useState(false);
    const [state, setData] = useState({
        surveys: ''
    });
    const [showSurveyForm, setshowSurveyForm] = useState(false);
    const [showSurveyView, setshowSurveyView] = useState(false);
    const [selectedSurvey, setselectedSurvey] = useState(null);
    const fetchData = async (pageNumber = 1) => {
        setloading(true)
        try {
            const result=await axios({
                url: Host + "surveys?page="+pageNumber,
                method: "get",
                headers: {
                "Authorization" : `Bearer ${token}`,
                    Accept:"application/json",
                    'X-localization':language,
                }
        
            })
            if(result && result.status == 200)
            {
                const surveys=result.data ;
                
                console.log(surveys);
                setData({
                    surveys:surveys 
                });
            } else if (result.data.status === false) {
                toast.error("Error")
            }
        } catch (error) {
            const responseResult=error.response            
            if (responseResult && responseResult.status === 400) {
                if(typeof responseResult.data.data === "object")
                {
                    const errorMessagesKeys = Object.keys(responseResult.data.data);
                    errorMessagesKeys.map((key)=>{
                    
                        responseResult.data.data[key].map((message)=>{
                            toast.error(message)
                        })
                    })
                }
                else{
                    toast.error(responseResult.data.data)
                }
                
            }
            else if(responseResult && responseResult.status === 401) {
                toast.error(responseResult.data.data)
                cookies.remove("token");
                window.location.href = "/"
            }
            else
            {
                toast.error("network error")
            }
        }
        setloading(false)
                   
    };
    const updateObject = async (object) => {
      
        setselectedSurvey(object)
        setshowSurveyForm(true)
    };
    
    
    const deleteObject = async (object) => {
        if (!window.confirm("Delete the item?")) {
            return
        }
        setloading(true)
        try {
            const result=await axios({
                url: Host + "surveys/"+object.id,
                method: "delete",
                headers: {
                "Authorization" : `Bearer ${token}`,
                    Accept:"application/json",
                    'X-localization':language,
                }
        
            })
            if(result && result.status == 200)
            {
                toast.error(result.data.data)
                fetchData();
            } else if (result.data.status === false) {
                toast.error("Error")
            }
        } catch (error) {
            const responseResult=error.response            
            if (responseResult && responseResult.status === 400) {
                if(typeof responseResult.data.data === "object")
                {
                    const errorMessagesKeys = Object.keys(responseResult.data.data);
                    errorMessagesKeys.map((key)=>{
                    
                        responseResult.data.data[key].map((message)=>{
                            toast.error(message)
                        })
                    })
                }
                else{
                    toast.error(responseResult.data.data)
                }
                
            }
            else if(responseResult && responseResult.status === 401) {
                toast.error(responseResult.data.data)
                cookies.remove("token");
                window.location.href = "/"
            }
            else
            {
                toast.error("network error")
            }
        }
        setloading(false)
    };
  
    const createObject = async (object) => {
        setselectedSurvey(null)
        setshowSurveyForm(true)
    };
    const buildObject = async (object) => {
        setselectedSurvey(null)
        setshowSurveyForm(true)
    };

   
    const handleSetshowSurveyForm = (openStatus,needsReload) => {
      if(needsReload)
      fetchData();
      setshowSurveyForm(openStatus)
    };

    const handleSetshowSurveyView = (openStatus,needsReload) => {
        if(needsReload)
            fetchData();
        setshowSurveyView(openStatus)
    };

    const viewObject = async (object) => {
        setselectedSurvey(object)
        console.log(showSurveyView);
        setshowSurveyView(true)
    }
   
    
    useEffect(() => {
        fetchData();
    }, [])
    
    return (
        <>
            {showSurveyForm?
                <SurveyForm survey={selectedSurvey} showSurveyForm={showSurveyForm} setshowSurveyForm={handleSetshowSurveyForm} />
            :null}
            {showSurveyView?
                <SurveyView survey={selectedSurvey} showSurveyView={showSurveyView} setshowSurveyView={handleSetshowSurveyView} />
            :null}
            
            
            
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">Survey List<Button style={{float:'right'}} onClick={()=>{createObject()}}>create</Button></div>
                            <div className="card-body">
                            <table>
                                <thead>
                                    <tr>
                                        <th>1</th>
                                        <th>Name</th>
                                        <th>Point Status</th>
                                        <th>Point Name</th>
                                        <th>View</th>
                                        <th>Build</th>
                                        <th>edit</th>
                                        <th>delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {   
                                    state?.surveys?.data ? 
                                        state?.surveys?.data?.map((object) => (
                                                <tr key={object?.id}>
                                                    <td>{object?.id}</td>
                                                    <td>{object?.name}</td>
                                                    
                                                    <td>{object?.point_type?.name}</td>
                                                    <td>{object?.point?.name}</td>
                                                    <td><Button onClick={()=>{viewObject(object)}}>View</Button></td>
                                                    <td><Button onClick={()=>{updateObject(object)}}>update</Button></td>
                                                    <td><Button style={{backgroundColor:'red',color:'white'}} onClick={()=>{deleteObject(object)}}>delete</Button></td>
                                                    <td><Button onClick={()=>{
                                                        
                                                        window.open(FrontEndDomain + `build_survey?id=${object?.id}`, '_blank')
                                                    }}>Build</Button></td>
                                                </tr>
                                        )) : "Loading..."
                                }
                                </tbody>
                            </table>
                                <div>
                                    <Pagination
                                        activePage={state?.surveys?.current_page ? state?.surveys?.current_page : 0}
                                        itemsCountPerPage={state?.surveys?.per_page ? state?.surveys?.per_page : 0 }
                                        totalItemsCount={state?.surveys?.total ? state?.surveys?.total : 0}
                                        onChange={(pageNumber) => {
                                            fetchData(pageNumber)
                                        }}
                                        pageRangeDisplayed={8}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        firstPageText="First Page"
                                        lastPageText="Last Lage"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Surveys;


